import { render, staticRenderFns } from "./AppIcon.vue?vue&type=template&id=6b5e8ff5"
import script from "./AppIcon.vue?vue&type=script&lang=ts"
export * from "./AppIcon.vue?vue&type=script&lang=ts"
import style0 from "./AppIcon.vue?vue&type=style&index=0&id=6b5e8ff5&prod&module=true&lang=scss"
import style1 from "./AppIcon.vue?vue&type=style&index=1&id=6b5e8ff5&prod&lang=scss"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports